export default __webpack_public_path__ + "static/media/pendigs_icon_header.7c25d4db.svg";